<template>
<div class="chapter">
<div class="inner_page">
<h2 id="c2"><span class="calibre1">CHAPTER II</span>
<br class="calibre8"/>
<span class="h2line">AMATEUR NIGHT</span></h2>
<p class="calibre3">The unfortunate reporter who had made the
mistake, and who had been discharged in consequence,
left the room. He had gained his position
under somewhat false pretenses, and so
there was little sympathy felt for him.</p>
<p class="calibre3">“We don’t want careless work on the <i class="calibre9">Leader</i>,”
went on Mr. Emberg, speaking to no one in particular.
“We want the news, and those who have
no noses for it had better look alive. We’re
in the news business, and that’s what we have
to give the people.”</p>
<p class="calibre3">The reporter, to whom Mr. Emberg had given
the clipping, soon ascertained that, in the main,
it was correct. So a story was made up concerning
the Eleventh Ward meeting, and run in the
second edition of the <i class="calibre9">Leader</i>, much to the disgust
of the city editor, who hated to be “beaten.”</p>
<div class="calibre2" id="Page_11" title="11"></div>
<p class="calibre3">The rebuke the unfortunate reporter received
produced a feeling of uneasiness among the others
on the staff of the <i class="calibre9">Leader</i>, and there were
many whispered conferences among the men that
afternoon. However the “ax” did not fall
again, much to the relief of several who knew
they had not been doing as well as they might—the
“ax” being the reporter’s slang for getting
discharged.</p>
<p class="calibre3">When the last edition had been run off on the
thundering presses in the basement, the reporters
gathered in small groups in different parts
of the room, and began talking over the events
of the day. Larry saw his friend Harvey Newton
come in from an assignment.</p>
<p class="calibre3">“How did you make out to-day, Larry?” asked
Mr. Newton.</p>
<p class="calibre3">“Pretty fair,” responded the boy. “I didn’t
have any big stories, though.”</p>
<p class="calibre3">“They’ll come in time. Better go slow and
sure.”</p>
<p class="calibre3">“Did you strike anything good?”</p>
<p class="calibre3">“Not much. I’ve been down to City Hall all
day, working on a tip I got of some land deal
a political gang is trying to put through. Something
about a big tract in the Bronx, but I didn’t
land it.”</p>
<p class="calibre3">The remark made Larry stop and think. He
remembered his mother had, among her papers,
a deed to some land in that section of New York
City called the Bronx, because it was near a
small river of that name. The land had been
taken by Mr. Dexter in connection with some
deal, and had never been considered of any value.
One day, as told in the previous volume, Mrs.
Dexter was about to destroy the old deed, but
Larry restrained her. He thought the land might
some day be of value. So the document was put
away.</p>
<div class="calibre2" id="Page_12" title="12"></div>
<p class="calibre3">When Mr. Newton spoke Larry wondered if,
by any chance, the land the reporter mentioned
as being that over which a political deal was
being made, could be located near that which was
represented by the old deed. He made up his
mind to speak of it some time.</p>
<p class="calibre3">It was now about four o’clock, and, as the reporters
went off duty in half an hour, Mr. Emberg
was busy over the assignment book.</p>
<p class="calibre3">The <i class="calibre9">Leader</i> was an afternoon paper, but sometimes
there were things occurring at night that
had to be “covered” or attended to in order to
get an account of them for the next day. Usually
only very important events were covered at
night by the <i class="calibre9">Leader</i>, since the morning papers,
or news associations, got accounts of them.</p>
<p class="calibre3">Mr. Emberg came over toward Larry with a
slip of paper in his hand.</p>
<p class="calibre3">“How would you like to try your hand at a
funny story?” the city editor asked the boy.</p>
<p class="calibre3">“I’d like to, only I don’t know that I could do
it. What sort of a story is it?”</p>
<p class="calibre3">“Amateur night at a theater. Did you ever
see one?”</p>
<div class="calibre2" id="Page_13" title="13"></div>
<p class="calibre3">Larry said he had not, and Mr. Emberg explained
that the managers of certain cheap theaters,
in order to get some variety, frequently
had amateur nights at their playhouses. They
would allow any one who came along to go on
the stage between the acts of the regular performance,
and sing, dance, recite, do feats of
strength, or whatever the amateur considered his
specialty.</p>
<p class="calibre3">The audience, for the most part made up of
young men and women, seldom had much sympathy
to waste on the amateurs, and it must be
a very brave youth or maiden who essayed to do
a “stunt” under the circumstances.</p>
<p class="calibre3">“Here are two tickets to the Jollity Theater,”
said Mr. Emberg. “Go up there to-night, take
someone with you if you like, and give us a good
funny story to-morrow.”</p>
<p class="calibre3">Larry was delighted at being able to go to the
theater without paying, but he was a little doubtful
of his ability to do the story. However, he
resolved to try. He told his mother of it at supper
last night.</p>
<p class="calibre3">“I’ll take Jimmy with me,” said Larry.</p>
<p class="calibre3">“I’m afraid your brother’s too young to go out,
as you will have to stay rather late,” said Mrs.
Dexter. “Can’t you take Harry Lake?” referring
to a boy who lived on the floor below the
Dexter apartments.</p>
<p class="calibre3">“I guess I will,” replied the young reporter,
and soon he and Harry were on their way to the
theater.</p>
<div class="calibre2" id="Page_14" title="14"></div>
<p class="calibre3">The play was one of the usual melodramatic
sort but to Larry and Harry it was very interesting.
They watched eagerly through the first
act, as did hundreds around them, but there was
more interest displayed when the manager came
before the curtain.</p>
<p class="calibre3">He announced that a number of amateurs had
come to go through their various “turns,” and
added that they would be allowed to stay and
amuse the audience as long as the latter seemed
to care for the offerings. When too much displeasure
was manifested the performers would be
obliged to withdraw, being forcibly reminded to
leave, sometimes, by being pulled from the boards
by a long-handled hook which the stage hands
stuck out from the wings, or sides of the stage.</p>
<p class="calibre3">“Johnny Carroll, in a song and dance specialty,”
announced the manager as the first number,
and then he retired to give place to Johnny.
The latter proved to be a tall, thin youth, who
shuffled out upon the stage and stood there looking
about rather sheepishly.</p>
<p class="calibre3">“Ladies an’ gen’men,” he began in such weak
tones that someone shouted:</p>
<p class="calibre3">“Take your voice out yer pocket!”</p>
<p class="calibre3">“I’m goin’ t’ dance a jig!” cried Johnny, defiantly,
and the orchestra struck up a lively tune.
Three times the young performer tried to get into
step, but something seemed to be the matter with
his feet, for they would not jig. A general laugh
ran around.</p>
<div class="calibre2" id="Page_15" title="15"></div>
<p class="calibre3">“I’m goin’ t’ sing!” cried Johnny, in desperation.
“I’ll give you that latest song success, entitled,
‘Give Me Another Transfer, This One
Has Expired,’” and the orchestra began playing
the opening strains. Johnny opened his mouth
to sing, but, as his voice was rather less harmonious
than a crow’s, he was met with howls
of laughter.</p>
<p class="calibre3">“T’ou’t ye was goin’ t’ sing!” someone in the
top gallery shouted.</p>
<p class="calibre3">“Give me a chanst!” pleaded the performer.</p>
<p class="calibre3">“Get the hook! Get the hook!” shouted several,
and out from the wings came an instrument
like a shepherd’s crook. Johnny was removed
from the stage, protesting in vain.</p>
<p class="calibre3">“Sammy Snipe will play the mouth organ,”
announced the manager, and Sammy came on.
He seemed to be an old hand at the turn, for he
entered with an air of confidence, and was greeted
with some applause. He lost no time in talking,
but began to play, and made not unmusical
sounds on the harmonica. He made a “hit” with
the audience, and there were no discouraging remarks.
Sammy played several popular airs, and
then tried to play a jig and dance it at the same
time. Sammy would have done better, however,
to have stopped when he had the approval of his
audience. Unfortunately he could not divide his
attention between his playing and his dancing.
While he could do either separately, when he essayed
both he found he had tried to cover too
much territory. He started off on a lively air,
but, no sooner had he danced a few steps, than
he forgot to keep playing, and he soon lost time.
Then he tried to start dancing, and come in with
the music when he had the jig going well. This,
too, failed, for he soon forgot to dance, and only
played.</p>
<div class="calibre2" id="Page_16" title="16"></div>
<p class="calibre3">“Take him away; he’s no good!” the audience
shouted, and then came the fatal call: “Get the
hook!” and Sammy was removed.</p>
<p class="calibre3">Next a young woman appeared who tried to
recite “Curfew Shall Not Ring To-night!” The
audience either had no regard for the curfew, or
did not care to hear anything tragic. The young
woman got as far as the third line when there
was a series of groans that indicated anything
but enjoyment.</p>
<p class="calibre3">“Ding-dong! Ten o’clock! Time’s up!” called
someone, and the performer retired in confusion.</p>
<p class="calibre3">Larry and Harry were enjoying the efforts of
the amateurs more than they had the real show.
They were anxious for the second act to be over
to see what the unprofessional performers would
offer next.</p>
<p class="calibre3">When the curtain was rung down the second
time, leaving the heroine in great trouble and distress,
the next amateur performer was another
young woman who wanted to recite. She selected
“Paul Revere’s Ride,” and began in a loud
tone: “Listen, my Children——” but she had only
gone that far when someone in a high falsetto
voice called out:</p>
<p class="calibre3">“Oh mercy, mother, did you put the cat out,
and lock the door?”</p>
<div class="calibre2" id="Page_17" title="17"></div>
<p class="calibre3">This was too much for the elocutionist, and
she rushed off the stage in confusion. Next appeared
a tall young man with light hair, and a
purple necktie, who tried to sing: “Come Where
My Love Lies Dreaming.” He managed to make
himself heard through two lines, and then such a
chorus of yells, whistles, and cat-calls, mingled
with “Get the hook!” broke out, that he had to
stand helpless. He was game, however, and
Larry could see, by the motion of the youth’s
lips, that the performer was going through with
the song. But not a sound of it was heard, and
there was no second verse.</p>
<p class="calibre3">This was followed by two boys who managed
to get through some buck and wing dancing, winning
hearty applause. Next there was a youth
who essayed a tumbling act.</p>
<p class="calibre3">He, too, seemed to please, and did not get the
“hook.” Not so fortunate, however, was the
following performer, who was announced as a
“strong man.”</p>
<p class="calibre3">Several stage hands carried a number of heavy
weights out on the boards. The “strong man”
in pink tights, making several bows, lifted a few
dumb-bells.</p>
<p class="calibre3">“Aw, I kin do that meself!” exclaimed a disgusted
newsboy, leaning far over the edge of the
gallery. “Do a hard one, or go back home.”</p>
<p class="calibre3">The performer next tackled a big dumb-bell
that must have weighed several hundred pounds.
Either he had underestimated its heft, or he had
overestimated his powers, for he could not budge
it. He strained and tugged, but the bell did not
move.</p>
<div class="calibre2" id="Page_18" title="18"></div>
<p class="calibre3">“Fake! No good! Get the hook!” were some
of the cries that greeted the man.</p>
<p class="calibre3">He was pulled from the stage by some of the
hands, and two of them came on to move the
weights. Then it was disclosed that a trick had
been played on the “strong” man for the big
dumb-bell was merely made of wood, painted to
resemble iron. It had been fastened to the floor
with hooks, which accounted for the inability of
the performer to move it.</p>
<p class="calibre3">One of the stage hands, unfastening the bell,
lifted it easily with one hand. Then the laughter
broke out louder than ever, Larry and Harry
joining in.</p>
<p class="calibre3">Between the third and fourth acts other amateurs
appeared. Some did fairly well, but most
of them had a bad attack of stage fright, or
were scared by the remarks made to them by the
audience. Altogether it was a funny experience.</p>
<p class="calibre3">Larry was so anxious to make a good story
that he sat up after he reached home that night,
and wrote it out, just as he had seen it. He gave
it a lively touch, and made the most of the situations.
It was with some anxiousness, however,
that he placed the story on Mr. Emberg’s desk
the next morning.</p>
<div class="calibre2" id="Page_19" title="19"></div>
<div class="pg-boilerplate" id="calibre_pb_8"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0006.vue?2a19acc1